import React, { useState, useRef, useLayoutEffect } from 'react';
import { PropTypes } from 'prop-types';
import { CarouselProvider, Slider, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

const TemplateCarouselSlider_custom = ({ boxStyle, slideBoxSet, contentSet, contentCount, sliderId }) => {
  const [visibleSlides, setVisibleSlides] = useState(1);
  const slideBoxSize = slideBoxSet.width + slideBoxSet.margin * 2;
  const messageBoxDef = useRef(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  useLayoutEffect(() => {
    let clientWidth = messageBoxDef.current.clientWidth;
    setVisibleSlides(clientWidth / slideBoxSize);
    function handleResize() {
      clientWidth = messageBoxDef.current.clientWidth;
      setVisibleSlides(clientWidth / slideBoxSize);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [slideBoxSize]);

  const handleNextClick = () => {
    if (currentSlide + 2 !== contentCount) {
      setCurrentSlide(currentSlide + 2);
    }
  };

  const handleBackClick = () => {
    setCurrentSlide(currentSlide - 2);
  };

  return (
    <div className="_carousel_div" ref={messageBoxDef}>
      <CarouselProvider
        visibleSlides={visibleSlides}
        className="_message_temp_carousel_div"
        totalSlides={contentCount}
        dragEnabled={false}
        touchEnabled
        isPlaying={false}
        currentSlide={currentSlide}
      >
        <Slider style={{ outline: 'none' }} id={sliderId}>
          {contentSet()}
        </Slider>
        <ButtonBack className="_back_button" onClick={handleBackClick}>
          <i className="ri-arrow-left-circle-fill" />
        </ButtonBack>
        <ButtonNext className="_next_button" onClick={handleNextClick}>
          <i className="ri-arrow-right-circle-fill" />
        </ButtonNext>
      </CarouselProvider>
    </div>
  );
};

TemplateCarouselSlider_custom.propTypes = {
  boxStyle: PropTypes.object,
  slideBoxSet: PropTypes.object,
  contentCount: PropTypes.number,
  contentSet: PropTypes.func,
  sliderId: PropTypes.string,
};

TemplateCarouselSlider_custom.defaultProps = {
  boxStyle: {},
  slideBoxSet: { width: 300, margin: 15, height: '200px' },
  contentCount: 0,
  contentSet: () => {},
  sliderId: 'slider',
};

export default TemplateCarouselSlider_custom;
